import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-upload-file-modal',
  templateUrl: './upload-file-modal.component.html',
  styleUrls: ['./upload-file-modal.component.scss']
})
export class UploadFileModalComponent implements OnInit, DwModalHandler {
  File: any;

  constructor() { }
  modalConfig: DwModalConfig<any>;
  closeModal: EventEmitter<DwModalResult<any>>;

  ngOnInit(): void {
  }
  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<any>> {
    const result: DwModalResult = new DwModalResult();
    result.closeModal = true;
    result.cancelled = false;
    if (buttonConfig.command == DwButtonCommand.cancel)
    {
      result.cancelled = true;
    }
    else{
    result.data = this.File;}

    return of(result);
  }
  uploadFile(file: any){
    this.File = file;
  }
}
